// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-sps-5-unisex-touchscreen-road-racing-motorcycle-mtb-sports-gloves",
  "entries": [
    {
      "id": "33377284980926",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-11.jpg?v=1783418585",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 11"
    },
    {
      "id": "33377284653246",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-01.jpg?v=1783418585",
      "alt": "color:White | Seibertron SPS-5 half finger motorcycle gloves image 01"
    },
    {
      "id": "33377284686014",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-02.jpg?v=1783418585",
      "alt": "color:White | Seibertron SPS-5 half finger motorcycle gloves image 02"
    },
    {
      "id": "33377284718782",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-03.jpg?v=1783418586",
      "alt": "color:White | Seibertron SPS-5 half finger motorcycle gloves image 03"
    },
    {
      "id": "33377284751550",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-04.jpg?v=1783418586",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 04"
    },
    {
      "id": "33377284784318",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-05.jpg?v=1783418585",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 05"
    },
    {
      "id": "33377284817086",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-06.jpg?v=1783418586",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 06"
    },
    {
      "id": "33377284849854",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-07.jpg?v=1783418585",
      "alt": "color:Black | Seibertron SPS-5 half finger motorcycle gloves image 07"
    },
    {
      "id": "33377284882622",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-08.jpg?v=1783418585",
      "alt": "color:Orange | Seibertron SPS-5 half finger motorcycle gloves image 08"
    },
    {
      "id": "33377284915390",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-09.jpg?v=1783418585",
      "alt": "color:Orange | Seibertron SPS-5 half finger motorcycle gloves image 09"
    },
    {
      "id": "33377284948158",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-10.jpg?v=1783418585",
      "alt": "color:Orange | Seibertron SPS-5 half finger motorcycle gloves image 10"
    },
    {
      "id": "33377285013694",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-12.jpg?v=1783418586",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 12"
    },
    {
      "id": "33377285046462",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-13.jpg?v=1783418585",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 13"
    },
    {
      "id": "33377285079230",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-14.jpg?v=1783418586",
      "alt": "color:Grey | Seibertron SPS-5 half finger motorcycle gloves image 14"
    },
    {
      "id": "33377285111998",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-15.jpg?v=1783418585",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 15"
    },
    {
      "id": "33377285144766",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-16.jpg?v=1783418585",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 16"
    },
    {
      "id": "33377285177534",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-17.jpg?v=1783418585",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 17"
    },
    {
      "id": "33377285210302",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-18.jpg?v=1783418586",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 18"
    },
    {
      "id": "33377285243070",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-19.jpg?v=1783418585",
      "alt": "color:Pink | Seibertron SPS-5 half finger motorcycle gloves image 19"
    },
    {
      "id": "33377285275838",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-20.jpg?v=1783418585",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 20"
    },
    {
      "id": "33377285308606",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-21.jpg?v=1783418585",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 21"
    },
    {
      "id": "33377285341374",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-22.jpg?v=1783418585",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 22"
    },
    {
      "id": "33377285374142",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-23.jpg?v=1783418585",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 23"
    },
    {
      "id": "33377285406910",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-24.jpg?v=1783418585",
      "alt": "color:Yellow | Seibertron SPS-5 half finger motorcycle gloves image 24"
    },
    {
      "id": "33377285439678",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-25.jpg?v=1783418585",
      "alt": "color:all | Seibertron SPS-5 half finger motorcycle gloves common image 25"
    },
    {
      "id": "33377285472446",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps5-unisex-half-finger-gallery-26.jpg?v=1783418586",
      "alt": "color:all | Seibertron SPS-5 half finger motorcycle gloves common image 26"
    }
  ],
  "variants": [
    {
      "id": "45277079732414",
      "title": "SPS-5 Half Finger Adult White / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Adult S"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277079765182",
      "title": "SPS-5 Half Finger Adult White / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Adult M"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277079797950",
      "title": "SPS-5 Half Finger Adult White / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Adult L"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277079830718",
      "title": "SPS-5 Half Finger Adult White / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Adult XL"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277079863486",
      "title": "SPS-5 Half Finger Adult White / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Adult XXL"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277079896254",
      "title": "SPS-5 Half Finger Adult White / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Adult XXXL"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277089005758",
      "title": "SPS-5 Half Finger Adult White / Youth XS",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Youth XS"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277089038526",
      "title": "SPS-5 Half Finger Adult White / Youth S",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Youth S"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277089071294",
      "title": "SPS-5 Half Finger Adult White / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Youth M"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277089104062",
      "title": "SPS-5 Half Finger Adult White / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Youth L"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277089136830",
      "title": "SPS-5 Half Finger Adult White / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult White"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult White",
        "Youth XL"
      ],
      "mediaId": "33377284653246"
    },
    {
      "id": "45277079929022",
      "title": "SPS-5 Half Finger Adult Black / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Adult S"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277079961790",
      "title": "SPS-5 Half Finger Adult Black / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Adult M"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277079994558",
      "title": "SPS-5 Half Finger Adult Black / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Adult L"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277080027326",
      "title": "SPS-5 Half Finger Adult Black / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Adult XL"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277080060094",
      "title": "SPS-5 Half Finger Adult Black / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Adult XXL"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277080092862",
      "title": "SPS-5 Half Finger Adult Black / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Adult XXXL"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277089169598",
      "title": "SPS-5 Half Finger Adult Black / Youth XS",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Youth XS"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277089202366",
      "title": "SPS-5 Half Finger Adult Black / Youth S",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Youth S"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277089235134",
      "title": "SPS-5 Half Finger Adult Black / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Youth M"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277089267902",
      "title": "SPS-5 Half Finger Adult Black / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Youth L"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277089300670",
      "title": "SPS-5 Half Finger Adult Black / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Black"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Black",
        "Youth XL"
      ],
      "mediaId": "33377284751550"
    },
    {
      "id": "45277080125630",
      "title": "SPS-5 Half Finger Adult Orange / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Adult S"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277080158398",
      "title": "SPS-5 Half Finger Adult Orange / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Adult M"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277080191166",
      "title": "SPS-5 Half Finger Adult Orange / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Adult L"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277080223934",
      "title": "SPS-5 Half Finger Adult Orange / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Adult XL"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277080256702",
      "title": "SPS-5 Half Finger Adult Orange / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Adult XXL"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277080289470",
      "title": "SPS-5 Half Finger Adult Orange / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Adult XXXL"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277089333438",
      "title": "SPS-5 Half Finger Adult Orange / Youth XS",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Youth XS"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277089366206",
      "title": "SPS-5 Half Finger Adult Orange / Youth S",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Youth S"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277089398974",
      "title": "SPS-5 Half Finger Adult Orange / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Youth M"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277089431742",
      "title": "SPS-5 Half Finger Adult Orange / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Youth L"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277089464510",
      "title": "SPS-5 Half Finger Adult Orange / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Orange"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Orange",
        "Youth XL"
      ],
      "mediaId": "33377284882622"
    },
    {
      "id": "45277080518846",
      "title": "SPS-5 Half Finger Adult Grey / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Adult S"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277080551614",
      "title": "SPS-5 Half Finger Adult Grey / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Adult M"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277080584382",
      "title": "SPS-5 Half Finger Adult Grey / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Adult L"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277080617150",
      "title": "SPS-5 Half Finger Adult Grey / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Adult XL"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277080649918",
      "title": "SPS-5 Half Finger Adult Grey / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Adult XXL"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277080682686",
      "title": "SPS-5 Half Finger Adult Grey / Adult XXXL",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Adult XXXL"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277089497278",
      "title": "SPS-5 Half Finger Adult Grey / Youth XS",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Youth XS"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277089530046",
      "title": "SPS-5 Half Finger Adult Grey / Youth S",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Youth S"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277089562814",
      "title": "SPS-5 Half Finger Adult Grey / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Youth M"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277089595582",
      "title": "SPS-5 Half Finger Adult Grey / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Youth L"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277089628350",
      "title": "SPS-5 Half Finger Adult Grey / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Grey"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Grey",
        "Youth XL"
      ],
      "mediaId": "33377284980926"
    },
    {
      "id": "45277080715454",
      "title": "SPS-5 Half Finger Adult Pink / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Adult S"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277080748222",
      "title": "SPS-5 Half Finger Adult Pink / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Adult M"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277080780990",
      "title": "SPS-5 Half Finger Adult Pink / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Adult L"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277080813758",
      "title": "SPS-5 Half Finger Adult Pink / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Adult XL"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277080846526",
      "title": "SPS-5 Half Finger Adult Pink / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Adult XXL"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277080879294",
      "title": "SPS-5 Half Finger Adult Pink / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Adult XXXL"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277089661118",
      "title": "SPS-5 Half Finger Adult Pink / Youth XS",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Youth XS"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277089693886",
      "title": "SPS-5 Half Finger Adult Pink / Youth S",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Youth S"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277089726654",
      "title": "SPS-5 Half Finger Adult Pink / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Youth M"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277089759422",
      "title": "SPS-5 Half Finger Adult Pink / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Youth L"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277089792190",
      "title": "SPS-5 Half Finger Adult Pink / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult Pink"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult Pink",
        "Youth XL"
      ],
      "mediaId": "33377285111998"
    },
    {
      "id": "45277080912062",
      "title": "SPS-5 Half Finger Adult FL Yellow / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Adult S"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277080944830",
      "title": "SPS-5 Half Finger Adult FL Yellow / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Adult M"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277080977598",
      "title": "SPS-5 Half Finger Adult FL Yellow / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Adult L"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277081010366",
      "title": "SPS-5 Half Finger Adult FL Yellow / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Adult XL"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277081043134",
      "title": "SPS-5 Half Finger Adult FL Yellow / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Adult XXL"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277081075902",
      "title": "SPS-5 Half Finger Adult FL Yellow / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Adult XXXL"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277089824958",
      "title": "SPS-5 Half Finger Adult FL Yellow / Youth XS",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XS"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Youth XS"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277089857726",
      "title": "SPS-5 Half Finger Adult FL Yellow / Youth S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth S"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Youth S"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277089890494",
      "title": "SPS-5 Half Finger Adult FL Yellow / Youth M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth M"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Youth M"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277089923262",
      "title": "SPS-5 Half Finger Adult FL Yellow / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Youth L"
      ],
      "mediaId": "33377285275838"
    },
    {
      "id": "45277089956030",
      "title": "SPS-5 Half Finger Adult FL Yellow / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "SPS-5 Half Finger Adult FL Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "SPS-5 Half Finger Adult FL Yellow",
        "Youth XL"
      ],
      "mediaId": "33377285275838"
    }
  ],
  "singleVariant": false,
  "colorSwatches": {},
  "optimizeColorSwatches": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var selectedColor = scope.querySelector('input[name="options[Color]"]:checked');
    var exactColorMediaId = selectedColor && config.colorSwatches ? config.colorSwatches[selectedColor.value] : '';
    if (exactColorMediaId) {
      var exactColorEntry = config.entries.find(function (entry) { return entry.id === exactColorMediaId; });
      if (exactColorEntry) return exactColorEntry;
    }
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var exactColorMediaId = optionName === 'Color' && config.colorSwatches ? config.colorSwatches[input.value] : '';
      var mediaIds = exactColorMediaId ? [exactColorMediaId] : config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function ensureScopedStyles(scope) {
    if (!config.optimizeColorSwatches || document.getElementById('sps5-gallery-swatch-layout-20260716')) return;
    var style = document.createElement('style');
    style.id = 'sps5-gallery-swatch-layout-20260716';
    style.textContent = [
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__thumb{display:grid!important;visibility:visible!important;opacity:1!important;flex:0 0 auto;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{display:grid!important;grid-template-columns:repeat(6,minmax(58px,1fr));gap:10px;width:100%;overflow:visible;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual{width:100%;min-width:0;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choice--visual>[data-auto-choice-label]{width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;aspect-ratio:1/1;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:#fff!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image,.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{width:100%!important;height:100%!important;display:block!important;}',
      '.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__swatch-image img{object-fit:contain!important;object-position:center!important;background:#fff!important;padding:3px!important;box-sizing:border-box!important;}',
      '@media(max-width:640px){.auto-product[data-product-handle="' + config.handle + '"] .auto-product__option[data-auto-option-position="1"] .auto-product__choices{grid-template-columns:repeat(3,minmax(64px,1fr));gap:10px;}}'
    ].join('');
    document.head.appendChild(style);
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    ensureScopedStyles(scope);
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
